import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataTableHeader } from './DataTableHeader';
import { ParamValueModel } from '../../models/ParamValueModel';
import { DataTable } from './DataTable';
import { Observable } from 'rxjs';
import {
  Breakpoint,
  MediaQueryService
} from '../../services/media-query.service';

declare var jQuery;

export interface CustomItemContext {
  item: any;
  row: any;
}

@Component({
  selector: 'app-data-table-component',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit {
  @Input() minWidth = '600px';
  @Input() id;
  @Input() domain;
  @Input() data: Array<DataTableHeader>;
  @Input() headers;
  @Input() subHeaders;
  @Input() subDataTables: Array<DataTable>;
  @Input() currentSort;
  @Input() asc: boolean;
  @Input() showAll: boolean;
  @Input() limit: number;
  @Output() itemClick: EventEmitter<ParamValueModel> =
    new EventEmitter<ParamValueModel>();
  @Input() reportTitle: string;
  @Input() isFreemium: boolean;
  @Input() maxValueMapping: any;
  showMore = false;
  showMoreArg = '';
  DEFAULT_LIMIT = 5;

  desktop$: Observable<boolean>;
  tablet$: Observable<boolean>;
  mobile$: Observable<boolean>;
  portrait$: Observable<boolean>;

  constructor(private mediaQueryService: MediaQueryService) {}

  ngOnInit() {
    // this.asc = false;
    this.desktop$ = this.mediaQueryService.gt(Breakpoint.md);
    this.tablet$ = this.mediaQueryService.lt(Breakpoint.lg);
    this.mobile$ = this.mediaQueryService.lte(Breakpoint.md);
    this.portrait$ = this.mediaQueryService.lte(Breakpoint.sm);

    if (this.limit === 0 || !this.limit) {
      this.limit = this.DEFAULT_LIMIT;
    }

    if (this.isFreemium) {
      this.limit = 2; // 2 only for Freemium access
    }

    this.showMoreArg = this.showMore + ',' + this.limit;
  }

  toggleShowMore() {
    if (!this.isFreemium) {
      this.showMore = !this.showMore;
      this.showMoreArg = this.showMore + ',' + this.limit;

      setTimeout(() => {
        jQuery('data-table img').on('error', evt => {
          jQuery(evt.target).attr('src', '/assets/images/logo-grey-16x16.png');
        });
        // jQuery('[data-toggle="tooltip"]').tooltip({animation: false});
      }, 100);
    }
  }

  sort(columnName) {
    if (!this.isFreemium) {
      this.showMore = true;
      this.showMoreArg = this.showMore + ',' + this.limit;

      if (this.currentSort !== columnName) {
        this.asc = true;
      } else {
        this.asc = !this.asc;
      }
      this.currentSort = columnName;

      const sarray = this.data;

      if (this.asc) {
        this.data = sarray.sort((n1, n2) => {
          // put N/A values at the end
          if (n1[columnName] === 'N/A' && n2[columnName] !== 'N/A') {
            return 1;
          }

          if (n1[columnName] !== 'N/A' && n2[columnName] === 'N/A') {
            return -1;
          }

          if (n1[columnName] === 'N/A' && n2[columnName] === 'N/A') {
            return 0;
          }

          if (n1[columnName].substring) {
            // compare as string

            if (n1[columnName].toLowerCase() > n2[columnName].toLowerCase()) {
              return 1;
            }

            if (n1[columnName].toLowerCase() < n2[columnName].toLowerCase()) {
              return -1;
            }
          } else {
            // compare as numbers
            if (n1[columnName] > n2[columnName]) {
              return 1;
            }

            if (n1[columnName] < n2[columnName]) {
              return -1;
            }
          }

          return 0;
        });
      } else {
        this.data = sarray.sort((n1, n2) => {
          // put N/A values at the beginning
          if (n1[columnName] === 'N/A' && n2[columnName] !== 'N/A') {
            return -1;
          }

          if (n1[columnName] !== 'N/A' && n2[columnName] === 'N/A') {
            return 1;
          }

          if (n1[columnName] === 'N/A' && n2[columnName] === 'N/A') {
            return 0;
          }

          if (n1[columnName].substring) {
            // compare as string

            if (n1[columnName].toLowerCase() > n2[columnName].toLowerCase()) {
              return -1;
            }

            if (n1[columnName].toLowerCase() < n2[columnName].toLowerCase()) {
              return 1;
            }
          } else {
            // compare as numbers
            if (n1[columnName] > n2[columnName]) {
              return -1;
            }

            if (n1[columnName] < n2[columnName]) {
              return 1;
            }
          }

          return 0;
        });
      }
    }
  }

  goTo(param: string, paramValue: string) {
    this.itemClick.emit({ param: param, paramValue: paramValue });
  }
}
